import { MovesHistory } from "@/types/types"
import Line from "./Line"
import { useGameMoves } from "@/hooks/useGameMoves"

const MovesList = ({
  depth,
  moves,
  hideFuture = false,
}: {
  depth: number
  moves: MovesHistory
  hideFuture?: boolean
}) => {
  const { activeMove, goToMove } = useGameMoves()
  const linePosition = activeMove[depth]

  if (depth === 0 && !moves?.length) {
    return (
      <div className="flex items-center justify-center text-center">
        <p className="text-sm font-medium text-gray-900">
          Make the first move!
        </p>
      </div>
    )
  }

  return moves.map((lineMoves, i) => (
    <Line
      key={i}
      index={i}
      moves={lineMoves}
      depth={depth}
      active={linePosition && linePosition[0] === i}
      activeMoveIndex={linePosition && linePosition[1]}
      position={activeMove.slice(0, depth)}
      onMoveClick={goToMove}
      hideFuture={hideFuture}
    />
  ))
}

export default MovesList
